
















import Vue from 'vue';
import config from '../../../../../config';

interface IImageWithErrorMessage {
  fallbackImage: string;
}

export default Vue.extend({
  name: `ImageWithErrorMessage`,
  data(): IImageWithErrorMessage {
    return {
      fallbackImage: config.images.fallbackImage,
    };
  },
  props: {
    alt: {
      default: ``,
      type: String,
    },
    imageUrl: {
      required: true,
      type: String,
    },
    showErrorMessage: {
      default: true,
      type: Boolean,
    },
    uniqueHtmlImageId: {
      required: true,
      type: String,
    },
  },
  methods: {
    onImageLoadFail(): void {
      const errorImage: HTMLImageElement = this.$refs[`error-image-${this.uniqueHtmlImageId}`] as HTMLImageElement;
      const errorMessage: HTMLElement = this.$refs[`error-message-${this.uniqueHtmlImageId}`] as HTMLElement;

      errorImage.src = this.fallbackImage;
      errorImage.style.opacity = `0.5`;

      if(this.showErrorMessage) {
        errorMessage.style.display = `inherit`;
      }
    },
  },
});
